// @ts-ignore
import ExperienceStep from './Steps/Experience/ExperienceStep';
// @ts-ignore
import ProfileStep from './Steps/Profile/ProfileStep';
// @ts-ignore
import WorkExperienceStep from './Steps/WorkExperience/WorkExperienceStep';
// @ts-ignore
import AddressStep from './Steps/Address/AddressStep';
// @ts-ignore
import DocumentsStep from './Steps/Documents/DocumentsStep';
// @ts-ignore
import AvailabilityStep from './Steps/Availability/AvailabilityStep';
import Step from '~/components/Flows/Build/Step';
import Flow from '~/components/Flows/Build/Flow';
import RelocationEnum from "~/enums/RelocationEnum";
import ExperienceTierEnum from "~/enums/ExperienceTierEnum";

export default ({ supportsRelocationFeature }: { supportsRelocationFeature?: boolean }): Flow => {
  const experienceStep = new Step({
    id: 'experience',
    slug: 'experience',
    component: ExperienceStep,
    props: ['applicant'],
    image: 'login',
    isComplete: ({ applicant }: { applicant: any }): boolean => {
      return !!applicant?.experience_tier;
    },
  });

  const profileStep = new Step({
    id: 'profile',
    slug: 'profile',
    component: ProfileStep,
    props: ['applicant'],
    image: 'login',
    // eslint-disable-next-line
    isComplete: ({ applicant }: { applicant: any }): boolean => {
      // eslint-disable-next-line
      return !!(
        applicant?.date_of_birth &&
        (
          applicant?.experience_tier === ExperienceTierEnum.JUNIOR
            ? applicant.graduated_at
            : true
        )
      );
    },
  });

  const workExperienceStep = new Step({
    id: 'work-experience',
    slug: 'work-experience',
    component: WorkExperienceStep,
    props: ['applicant'],
    image: 'login',
    // eslint-disable-next-line
    isComplete: ({ applicant }: { applicant: any }): boolean => {
      // eslint-disable-next-line
      return !!(applicant?.experience_domain_ids?.length && applicant?.last_position);
    },
  });

  const addressStep = new Step({
    id: 'address',
    slug: 'address',
    component: AddressStep,
    props: ['applicant'],
    image: 'login',
    // eslint-disable-next-line
    isComplete: ({ applicant }: { applicant: any }): boolean => {
      // eslint-disable-next-line
      return !!(applicant?.address && applicant?.meta?.phonenumber);
    },
  });

  const availabilityStep = new Step({
    id: 'availability',
    slug: 'availability',
    component: AvailabilityStep,
    props: ['applicant'],
    image: 'login',
    // eslint-disable-next-line
    isComplete: ({ applicant }: { applicant: any }): boolean => {
      // eslint-disable-next-line
      return !!(
        applicant?.available_from &&
        (supportsRelocationFeature
          ? (applicant?.relocation && applicant?.relocation !== RelocationEnum.UNKNOWN)
          : true
        )
      );
    },
  });

  const documentsStep = new Step({
    id: 'documents',
    slug: 'documents',
    component: DocumentsStep,
    props: ['applicant'],
    image: 'login',
    // eslint-disable-next-line
    isComplete: (): boolean => {
      // eslint-disable-next-line
      return true;
    },
  });

  return new Flow([
    experienceStep,
    profileStep,
    workExperienceStep,
    addressStep,
    availabilityStep,
    documentsStep,
  ]);
};
